import {
  GET_RAFFLE_MY_TICKET_LIST_REQUEST,
  GET_RAFFLE_MY_TICKET_LIST_SUCCESS,
  GET_RAFFLE_MY_TICKET_LIST_FAILURE,
  GET_RAFFLE_MY_TICKET_LIST_RESET,
  RAFFLE_MY_TICKETS_TABS
} from 'Store/constants';

const initialState = {
  tabs: {
    data: {}
  },
  ticketList: {
    data: {
      tickets: []
    },
    isLoading: null,
    error: null,
    pagination: {
      pageSize: 10,
      pageIndex: 0,
      hasMore: null,
      start: 1,
      end: 11
    }
  },
  ticketDetail: {
    data: {},
    isLoading: null,
    error: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {

    case GET_RAFFLE_MY_TICKET_LIST_REQUEST:
      return {
        ...state,
        ticketList: {
          ...state.ticketList,
          isLoading: true,
          error: null
        }
      };

    case GET_RAFFLE_MY_TICKET_LIST_SUCCESS:
      return {
        ...state,
        ticketList: {
          data: {
            tickets: [...state.ticketList.data.tickets, ...action.payload.tickets]
          },
          isLoading: false,
          error: null,
          pagination: {
            ...state.ticketList.pagination,
            ...action.pagination
          }
        }
      };

    case GET_RAFFLE_MY_TICKET_LIST_FAILURE:
      return {
        ...state,
        ticketList: {
          ...state.ticketList,
          isLoading: false,
          error: action.payload,
          pagination: {
            ...state.ticketList.pagination,
            hasMore: false
          }
        }
      };
    
    case GET_RAFFLE_MY_TICKET_LIST_RESET:
      return {
        ...state,
        ticketList: initialState.ticketList
      };

    case RAFFLE_MY_TICKETS_TABS:
      return {
        ...state,
        tabs: {
          data: action.payload
        }
      };

    default:
      return state;
  }
};
